import React, { useId } from "react";

export default function CustomerProfileSection({
  title,
  actions,
  headingClassName = "",
  children,
}) {
  const headingId = useId();
  return (
    <section className="prf-section" aria-labelledby={headingId}>
      <header className={"prf-sum " + headingClassName}>
        <h2 id={headingId} className="prf-section-title">
          {title}
        </h2>
        {actions && <div className="prf-section-actions">{actions}</div>}
      </header>
      {children}
    </section>
  );
}
